/**
 * Capacitor shell integration (iOS/Android): splash hand-off, the Android back button, and
 * background/foreground handling (audio, delivery of store purchases).
 */
import { audio } from '../game/audio/Audio';
import { navigateBack } from './back';
import { isNativeApp } from './platform';
import { recoverPurchases } from './state/actions';
import { launch } from './state/play';

export async function initNativeShell(): Promise<void> {
  if (!isNativeApp) return;
  const [{ App }, { SplashScreen }] = await Promise.all([import('@capacitor/app'), import('@capacitor/splash-screen')]);
  // Hide the native splash once the web UI has painted (it also auto-hides as a safety net).
  requestAnimationFrame(() => requestAnimationFrame(() => void SplashScreen.hide({ fadeOutDuration: 200 }).catch(() => {})));

  await App.addListener('backButton', () => {
    if (launch.value) {
      // In a match the back button toggles the pause menu, like Escape on desktop.
      window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape' }));
      return;
    }
    if (!navigateBack()) void App.minimizeApp().catch(() => {});
  });
  await App.addListener('pause', () => {
    void audio.ctx?.suspend().catch(() => {});
  });
  await App.addListener('resume', () => {
    void audio.ctx?.resume().catch(() => {});
    // Pending payments and Ask to Buy approvals often complete while the app is in the background.
    void recoverPurchases().catch(() => {});
  });
}
